import React, { useEffect, useContext, useState, Fragment } from 'react';
import farmerContext from "../../../context/farmer/farmerContext";



const AddBank = ({disabled}) => {
    const FarmerContext = useContext(farmerContext);
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const { updateBank,farmer,addBank } = FarmerContext;
    const { banks, userBank} = farmer;
    const [bankCode, setBankCode] = useState("");

    const [account_name, setaccount_name] = useState('');
    const [account_number, setaccount_number] = useState('');
    const [account_type, setaccount_type] = useState('');
    const [bank_name, setbank_name] = useState('');


    let bankDetail =  banks.filter(function(bank) {
        return bank.code === bankCode ? bank : "";
    });

    useEffect(() => {
        console.log(userBank)
        if (userBank !== null) {
            setaccount_name(userBank.account_name)
            setaccount_number(userBank.account_number)
            setaccount_type(userBank.account_type)
            setbank_name(userBank.bank_name)
        } else {
            setaccount_name('')
            setaccount_number('')
            setaccount_type('')
            setbank_name('')
        }
        //eslint-disable-next-line
    }, [userInfo]);

    const handleSubmit = (e) => {
        e.preventDefault();
        let  bank_form = document.getElementById("add_bank")
        let bank_data = new FormData(bank_form);
        let bankInfo = bankDetail
        console.log(bankInfo)
        bankInfo.map(bank=>(
            bank_data.append('bank_name',  bank.name),
            bank_data.append('bank_id', bank.id)
            )
        )
        
        if(userBank === null){
            addBank(bank_data)
        }
        else{
           updateBank(bank_data)
        }    

    };

    return (
        <Fragment>
                    <div className="page-container mt-3" style={disabled ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                        <div className="main-content">
                            <div className="row justify-content-md-center">
                                <div className="col-md-7">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center mb-10 mb-lg-20">
                                                <h3 className="font-size-h1">Manage Bank Account</h3>
                                                <p className="text-muted font-weight-bold">
                                                    Create Or Update Bank details
                        </p>
                                            </div>

                                            <form
                                                id="add_bank"
                                                onSubmit={handleSubmit}
                                                encType="multipart/form-data"
                                            >
                                                <div class="form-group mb-5">
                                                    <label>Account Name</label>
                                                    <input type="text" id="account_name"
                                                        name="account_name" class="form-control form-control-custom-view" defaultValue={userBank !== null && userBank.account_name}
                                                        required />
                                                </div>


                                                <div class="form-group mb-5">
                                                    <label>Bank Name</label>
                                                    <select className="form-control " value={userBank !== null ? userBank.code:""} name="bank_code" onChange={e => setBankCode(e.target.value)} id="bank_code" >
                                                    {banks!== null ? banks.map(bank => (
                                                        <option value={bank.code} key={bank.code}>{bank.name}</option>
                                                    )):(<p>No data available</p>)
                                                    }
                                                    </select>
                                                </div>

                                                <div class="form-group mb-5">
                                                    <label>Account Number:</label>
                                                    <input type="number" id="account_number" defaultValue={userBank !== null ? userBank.account_number : ""} name="account_number" class="form-control form-control-custom-view"
                                                        required />
                                                </div>

                                                <div class="form-group mb-5">
                                                    <label>Account Type:</label>
                                                    <select class="form-control" name="account_type" defaultValue={userBank !== null ? userBank.account_type : ""} required>
                                                        <option value="1">CURRENT</option>
                                                        <option value="0">SAVINGS</option>
 
                                                    </select>
                                                </div>

                                                <input
                                                    type="hidden"
                                                    name="user_id"
                                                    defaultValue={userInfo.id}
                                                />

                                                {userBank === null && !disabled ? (<div class="mt-5">
                                                    <button type='submit' className="btn btn-orange btn-block text-white">Create Bank</button>
                                                </div>): disabled ? ("") : (<div class="mt-5">
                                                    <button type='submit' className="btn btn-orange btn-block text-white">Update Bank</button>
                                                </div>)

                                                }
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        </Fragment>
    )

}



export default AddBank